import {
  Icon16Alert,
  Icon16Checkmark,
  Icon16Info,
  Typography,
} from "@cur8/maneki";
import { ComponentType, ReactNode } from "react";
import styles from "./styles.module.sass";

export type BannerKind = "success" | "info" | "error";

const BANNER_ICON: Record<BannerKind, ComponentType> = {
  success: Icon16Checkmark,
  info: Icon16Info,
  error: Icon16Alert,
};

interface BannerProps {
  kind: BannerKind;
  compact?: boolean;
  action?: ReactNode;
  children: ReactNode;
}

export function Banner({
  kind,
  compact = false,
  action,
  children,
}: BannerProps) {
  const Icon = BANNER_ICON[kind];
  return (
    <div className={styles.Banner} data-kind={kind} data-compact={compact}>
      <Icon />
      <Typography variant={compact ? "body-xs" : "body-m"}>
        {children}
      </Typography>
      {action ? <div className={styles.action}>{action}</div> : undefined}
    </div>
  );
}
